export const AUTOPLAY_PARAM = "autoplay";

/** Browsers only allow autoplay for muted media, so `muted` + `silent-autoplay`
 *  are required alongside `autoplay`. Spread only when autoplay is wanted. */
export const WISTIA_AUTOPLAY_ATTRS = {
  autoplay: "true",
  muted: "true",
  "silent-autoplay": "true",
} as const;

type WistiaIframeOptions = {
  autoplay?: boolean;
};

/** Wistia iframe embed URL with captions enabled for WCAG compliance. */
export function buildWistiaIframeSrc(
  mediaId: string,
  { autoplay = false }: WistiaIframeOptions = {},
): string {
  const params = new URLSearchParams({
    videoFoam: "true",
    captionsOnByDefault: "true",
    captionLanguage: "eng",
  });

  if (autoplay) {
    params.set("autoPlay", "true");
    params.set("muted", "true");
    params.set("silentAutoPlay", "true");
  }

  return `https://fast.wistia.net/embed/iframe/${encodeURIComponent(mediaId)}?${params.toString()}`;
}

/** Autoplay on by default; `?autoplay=0` (or `false`/`off`/`no`) opts out. */
export function parseAutoplay(value: string | string[] | undefined): boolean {
  const raw = Array.isArray(value) ? value[0] : value;
  if (raw == null) return true;
  return !["0", "false", "off", "no"].includes(raw.toLowerCase());
}
